export default "__VITE_ASSET__Bki9VvIw__"